// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "bbc8ee0b44ccb91f","396": "42988611fb3fb627","460": "c2c732e44ba57ad6","917": "f5b24c8805c9679e","985": "03921208405febee",}[chunkId] + ".chunk.js"
}